import request, {getRequest, postRequest, putRequest} from "./request";
import qs from "qs"
import {KEY_MACHINEID, KEY_RANDOM, KEY_USER_INFO, KEY_WEB_MACHINEID} from "@/Const";
import CryptoJS from "crypto-js"
import global from "@/global";

/**
 * 登录
 * @param params
 */
export function login(params:any,errCallback){
    return postRequest(
        {
            url:"/api/v1/user/app/login",
            data:(params),
            callback:errCallback
        }
    )
}

/**
 * 用户信息
 * @param params
 * @param errCallback
 */
export function getUserInfo(params:any,errCallback){
    // console.log('get user info .....');
    return new Promise((resolve, reject) => {
        getRequest({
            url:'/api/v1/user/app/info',
            data: {},
            callback:errCallback
        }).then(res=>{
            //保存用户信息....
            if (import.meta.env.DEV){
                res.desktopProBasicLicense = '';
                res.desktopProLicense = 'lic';
                res.desktopProMaxLicense = '';
                res.desktopProPlusLicense = ''
                // res.publisher4BizLicense = 'xxxx';
                res.publisherLicense = '';
                // res.desktopProBasicLicense = '';
            }
            console.log(res);
            global.g_userInfo = res;
            const szText = JSON.stringify(res);
            const szData = CryptoJS.AES.encrypt(szText,'muenzo'+KEY_RANDOM).toString();
            localStorage.setItem(KEY_USER_INFO,szData);
            resolve(res);
        })
    })
}

/**
 * 激活
 * @param szLic
 * @param errCallback
 */
export function deviceActive(szLic:string,errCallback){
    return postRequest({
        url:'/api/v1/desktop/devices/active',
        data:{licenseKey:szLic,deviceId:localStorage.getItem(KEY_MACHINEID)},
        callback:errCallback
    })
}

/**
 * 检查更新
 * @param errCallback
 */
export function checkUpdate(errCallback){
    return getRequest({url:'',data:{},callback:errCallback})
}

/**
 * 发布笔记
 * @param data
 * @param errCallback
 */
export function notePublish(data,errCallback){
    return putRequest({
        url:'/api/v1/notes/publish/d',
        data,
        callback:errCallback
    })
}

export function apiSecondLevelDomain(szDomain:string,errCallback){
    return getRequest({url:'/api/v1/notes/second-level-domain/'+szDomain,data:{},callback:errCallback})
}

export function sendGetRequest(url,errCallback:any){
    return getRequest({url:url,data:{},callback:errCallback});
}

//获取笔记
export function noteInfoById(id,errCallback,isVistor=true){
    return getRequest({url:'/api/v1/notes/'+id+(isVistor?'?visitor='+localStorage.getItem(KEY_WEB_MACHINEID):''), data:{}, callback:errCallback})
}


/**
 * 取消发布笔记
 * @param data
 * @param errCallback
 */
export function noteRemovePublish(data,errCallback){
    return putRequest({
        url:'/api/v1/notes/publish/remove',
        data,
        callback:errCallback
    })
}

/**
 * 分享数据
 * @param params
 */
export function shareCanvas(params:any){
  return request(
    {
      url:"http://106.75.20.145:8806/api/note/shareCanvas",
      method:'post',
      data:params
    });
}

/**
 * 取数据
 * @param params
 */
export function canvasContent(params:any){
  return request({
    url:"http://106.75.20.145:8806/api/note/canvasContent",
    method:'post',
    data:qs.stringify(params)
  })
}






























